import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';
import { isRdtErrorResponse } from '@/ui-kit/utils';
import { UserType } from '@/bo-kit/types';
import { LoginAndResetPassErrorCode } from '../transport/types';
import { isLoginResponseVerifyRequiredError } from '../utils/isLoginResponseVerifyRequiredError';

type ChooseRoleResponse = {
    message: 'role conflict';
    data: { available_roles: UserType[]; code?: 'ROLECONFLICT' };
};

const isChooseRoleResponse = (response: unknown): response is ChooseRoleResponse =>
    response != null &&
    ((response as Partial<ChooseRoleResponse>).data?.code === 'ROLECONFLICT' ||
        (response as Partial<ChooseRoleResponse>).message === 'role conflict');

export const useLoginErrorCode = (state: {
    error?: FetchBaseQueryError | SerializedError;
}): { errorCode?: LoginAndResetPassErrorCode; roles?: UserType[] } => {
    if (state.error === undefined) {
        return {};
    }
    if (
        'status' in state.error &&
        state.error.status === 409 &&
        isChooseRoleResponse(state.error.data)
    ) {
        return {
            errorCode: LoginAndResetPassErrorCode.ROLECONFLICT,
            roles: state.error.data.data.available_roles,
        };
    }

    if ('data' in state.error && isLoginResponseVerifyRequiredError(state.error.data)) {
        return { errorCode: LoginAndResetPassErrorCode.NOT_ACTIVATED_USER };
    } else if ('data' in state.error && isRdtErrorResponse(state.error.data)) {
        for (const errorCode of Object.values(LoginAndResetPassErrorCode)) {
            if (errorCode === state.error.data.rdt_code) {
                return { errorCode };
            }
        }
        return { errorCode: LoginAndResetPassErrorCode.UNKNOWN };
    }
    if ('status' in state.error && state.error.status === 'FETCH_ERROR') {
        return { errorCode: LoginAndResetPassErrorCode.NETWORK_ERROR };
    }
    if (state.error !== undefined) {
        return { errorCode: LoginAndResetPassErrorCode.UNKNOWN };
    }
    return {};
};
